export default __webpack_public_path__ + "static/media/grafema_capitolio_14.d4ed0adf.jpg";